import { render } from "./ClinicFlagsTab.vue?vue&type=template&id=2c08f8bf&scoped=true"
import script from "./ClinicFlagsTab.vue?vue&type=script&lang=js"
export * from "./ClinicFlagsTab.vue?vue&type=script&lang=js"

import "./ClinicFlagsTab.vue?vue&type=style&index=0&id=2c08f8bf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c08f8bf"]])

export default __exports__